import { render, staticRenderFns } from "./gov_announce_single.vue?vue&type=template&id=4d37c793&lang=pug"
import script from "./gov_announce_single.vue?vue&type=script&lang=js"
export * from "./gov_announce_single.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports